var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPalau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 40C31.046 40 40.0003 31.0457 40.0003 20C40.0003 8.95429 31.046 -1.52588e-05 20.0003 -1.52588e-05C8.95461 -1.52588e-05 0.000305176 8.95429 0.000305176 20C0.000305176 31.0457 8.95461 40 20.0003 40Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6524 28.6956C20.4549 28.6956 24.348 24.8025 24.348 20C24.348 15.1975 20.4549 11.3044 15.6524 11.3044C10.85 11.3044 6.95679 15.1975 6.95679 20C6.95679 24.8025 10.85 28.6956 15.6524 28.6956Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalau);
export default __webpack_public_path__ + "static/media/palau.f1da6459af2c293165f574a12a1f6707.svg";
export { ForwardRef as ReactComponent };